<script>
  import { apmonth, intcomma } from 'journalize';
  import { extent, range, ticks } from 'd3-array';
  import { scaleTime, scaleLinear } from 'd3-scale';
  import { timeMonth } from 'd3-time';
  import { curveStep, line } from 'd3-shape';

  export let allData;
  // export let race;
  export let candidates;
  export let width;
  // export let chartType;
  export let candidates_last;

  // let committeeTypes = [
  //   'Candidate committees',
  //   'Independent primarily formed committees',
  //   'Other independent committees',
  // ];

  var height = 320;
  var margin = { top: 40, bottom: 20, left: 30, right: 78 };

  let minDate = new Date('2021-01-01T00:00');
  let jan22 = new Date('2022-01-01T00:00');
  let electionDate = new Date('2022-11-08T00:00');
  let primary = new Date('2022-06-07T00:00');
  let latestFiling = new Date('2022-09-24T00:00');
  let today = new Date();
  //filter to right race
  // let data = allData.filter(d=>d.race == race & d.date > minDate)

  let data = allData.filter((d) => d.date > minDate);

  let filterCandidate = (cand) => {
    return data.filter((d) => d.candidate_name == cand);
  };

  let filterCandidateCom = (cand) => {
    return data.filter(
      (d) => (d.candidate_name == cand) & (d.committee_type == 'campaign')
    );
  };

  let filterCandidateGeneral = (cand) => {
    return data.filter(
      (d) => (d.candidate_name == cand) & (d.committee_type == 'general')
    );
  };

  // scales
  let extentX = [minDate, Math.min(today, electionDate)];

  let xScale = scaleTime()
    .domain(extentX)
    .range([margin.left + 20, width - margin.right]);

  let extentY = extent(data, (d) => d.cumsum);

  // get largest place value in tens
  let unit = Math.pow(10, Math.floor(Math.log10(extentY[1])));
  unit = 1000000; //just keep it at millions

  let maxY = Math.ceil(extentY[1] / unit) * unit;

  let yScale = scaleLinear()
    .domain([0, maxY])
    .range([height - margin.bottom, margin.top]);

  let path = line()
    .x((d) => xScale(d.date))
    .y((d) => yScale(d.cumsum))
    .curve(curveStep);

  // ticks for x axis
  let xTicks = [minDate, jan22, today];
  // x axis labels string formatting
  let xLabel = (x) => `${apmonth(x)} ${x.getFullYear()}`;

  let getLastName = (c) => {
    return c.split(' ').at(-1);
  };

  // ticks for y axis -

  let yTicks = ticks(0, maxY + 1, 5);

  // yTicks = yTicks.length > 10 ? yTicks.filter((element, index) => {
  // 	return index % 2 === 0;
  // }) : yTicks

</script>

<div class="chart" bind:clientWidth={width}>
  <div class="chart-hed">Cumulative fundraising totals, in millions</div>

  <svg>
    <!-- y axis -->
    <g class="yAxis" transform="translate({margin.left}, 0)">
      {#each yTicks as y, i}
        <g class="tick" opacity="1" transform="translate(0,{yScale(y)})">
          <line stroke="currentColor" x2={width - margin.right} />
          <text dy="0.32em" fill="currentColor" text-anchor="end" x="-{5}">
            {#if i == yTicks.length - 1}${/if}
            {y / unit}
          </text>
        </g>
      {/each}
    </g>

    <!-- x axis -->
    <g class="xAxis" transform="translate(0, {height - margin.bottom})">
      <line stroke="currentColor" x1={margin.left} x2={width - margin.right} />

      {#each xTicks as x}
        <g class="tick" opacity="1" transform="translate({xScale(x)},0)">
          <line stroke="currentColor" y2="6" />
          <text fill="currentColor" y="9" dy="0.71em" x="0">{xLabel(x)}</text>
        </g>
      {/each}
    </g>

    <g class="line annotation">
      <line
        x1={xScale(primary)}
        x2={xScale(primary)}
        y1={yScale(0)}
        y2="2"
        fill="none" />
      <text dx={xScale(Date.parse('2022-06-07')) - 35} dy="12">Primary</text>
    </g>

    <g class="line annotation">
      <line
        x1={xScale(latestFiling)}
        x2={xScale(latestFiling)}
        y1={yScale(0)}
        y2="2"
        fill="none" />
      <text dx={xScale(Date.parse('2022-09-24')) + 43} dy="12">
        Most recent
      </text>
      <text dx={xScale(Date.parse('2022-09-24')) + 23} dy="28">filing</text>
    </g>

    {#each candidates as c, index}
      {#if filterCandidate(c).length > 0}
        <g class="line" data-name="candidate-{c}">
          <!-- line -->
          <path
            d={path(filterCandidate(c))}
            fill="none"
            class="candidate-{index + 1} {getLastName(c)}" />
        </g>
        <g class="line" data-name="candidate-{index + 1}">
          <g
            transform="translate({xScale(
              filterCandidate(c).pop().date
            )} {yScale(filterCandidate(c).pop().cumsum)})">
            <circle class="candidate-{index + 1} {getLastName(c)}" r="4" />
            <text class="candidate-{index + 1} {getLastName(c)}" dx="10" dy="5">
              {candidates_last[index]}
            </text>
          </g>
        </g>
      {/if}
    {/each}
  </svg>
</div>
